module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/cleaning-desktop-99db430d1edd7d59da2ff119f5c6b285.jpg";